
import {
    defineComponent,
    ref,
} from 'vue';
import { accessor } from 'src/store';
import MonacoDiff from '../MonacoDiff/MonacoDiff.vue';

export const EntityDetailJSONDiff = defineComponent({
    name: 'EntityDetailJSONDiff',
    components: {
        MonacoDiff,
    },
    setup () {
        const editedEntityData = ref(accessor.entity?.entity || {});
        const originalEntityData = ref(accessor.originalEntity?.entity || {});

        const editedEntityDataString = JSON.stringify(editedEntityData.value, null, 2);

        const originalEntityDataString = JSON.stringify(originalEntityData.value, null, 2);

        return {
            editedEntityDataString,
            originalEntityDataString,
        };
    },
});
export default EntityDetailJSONDiff;

